import qs from 'qs';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';

import { withShowable } from '../../_global/lib/withShowable';
import { Step } from '../../../components/steppers/Step';

// @ts-expect-error TS(2339): Property 'children' does not exist on type '{}'.
export const Stepper = withShowable(({ children }) => {
  const classes = useStyles();
  return <ol className={`list--unstyled ${classes.list}`}>{children}</ol>;
});

export const Steps = ({
  children,
  step,
  id,
  isCompleted,
  jumpTo,
  lock,
}: any) => {
  const isComplete = isCompleted(id);

  return (
    <Step
      active={step === id}
      complete={isComplete}
      locked={lock || !isComplete}
    >
      {({ locked, getStepStyles }: any) =>
        locked ? (
          <li className={getStepStyles()}>{children}</li>
        ) : (
          <li className={getStepStyles()}>
            {/* @ts-expect-error: FIXME */}
            <Link onClick={() => jumpTo(id)} disabled={locked}>
              {children}
            </Link>
          </li>
        )
      }
    </Step>
  );
};

export const RenewalSteps = ({
  children,
  step,
  id,
  isCompleted,
  jumpTo,
  lock,
  path = '/agency/policies',
  queryParams = {},
}: any) => {
  const isComplete = isCompleted(id);
  const queryString = qs.stringify(queryParams, { addQueryPrefix: true });

  return (
    <Step active={step === id} complete={isComplete} locked={lock}>
        {({ locked, getStepStyles }: any) =>
          locked ? (
            <li className={getStepStyles()}>{children}</li>
          ) : (
            <li className={getStepStyles()}>
              <Link
                to={`${path}/${id}${queryString}`}
                onClick={() => jumpTo(id)}
                // @ts-expect-error TS(2322): Type '{ children: any; to: string; onClick: () => ... Remove this comment to see the full error message
                disabled={locked}
              >
                {children}
              </Link>
            </li>
          )
        }
      </Step>
  );
};

const useStyles = makeStyles(({ config }) => ({
  title: {
    textAlign: 'right',
    paddingRight: '33px',
    marginTop: '10 !important',
  },
  list: {
    display: 'flex',
    marginBottom: '1.3333333333rem !important',
    counterReset: 'Index',

    '& a': {
      color: `${config.colors.cowbellBlue} !important`,
    },

    '& .active': {
      borderBottom: `2px solid ${config.colors.cowbellBlue}`,
    },

    '& li': {
      paddingBottom: '0.1rem',
      fontSize: config.textSizes.paragon,
      color: `${config.colors.cowbellBlue} !important`,
      fontWeight: config.weights.bold,

      '&::before': {
        counterIncrement: 'Index',
        content: 'counter(Index) ". "',
      },
    },
  },
}));
